// extracted by mini-css-extract-plugin
module.exports = {"mainbox":"OrangeCard_mainbox__a_qvH","div4":"OrangeCard_div4__whObi","whyuscardmain":"OrangeCard_whyuscardmain___HXw2","whyuscard":"OrangeCard_whyuscard__Ivjg1"};